import type { AudioRegionParams } from "@/components/audio-player/AudioPlayer"
import type {
  MetricOutputDisplaySource,
  RunMetricOutput,
} from "@/types/RunMetricOutput"

import { NumericalMetricRecord } from "../base/NumericalMetricRecord"
import { WithAudioGateMixin } from "../mixins/WithAudioGateMixin"

export class SpeakingTimePercentageMetricRecord extends WithAudioGateMixin(
  NumericalMetricRecord,
) {
  overviewSize = "medium" as const
  unit = "%"
  aggregate_units = "%"

  get hasVersionedConfig(): boolean {
    return true
  }

  _renderDeepDive(mo: RunMetricOutput): React.ReactNode {
    if (mo.float_value == null || !Number.isFinite(mo.float_value)) {
      return null
    }

    const resultRecord = (mo.result ?? {}) as Record<string, unknown>
    const rawValues = (resultRecord.raw_values ?? {}) as Record<string, unknown>
    const roleDuration = rawValues.role_duration_seconds as number | undefined
    const segmentCount = resultRecord.count as number | undefined

    return (
      <div className="space-y-3">
        <div className="flex items-baseline gap-2">
          <span className="text-2xl font-bold">
            {mo.float_value.toFixed(1)}%
          </span>
        </div>
        {roleDuration != null && (
          <div className="text-sm text-coval-text-muted">
            {roleDuration.toFixed(1)}s
            {segmentCount != null && ` (${segmentCount} segments)`}
          </div>
        )}
      </div>
    )
  }

  getAudioRegions(
    mo: MetricOutputDisplaySource | undefined,
  ): AudioRegionParams[] {
    if (mo?.error_message || !mo?.subvalues_by_timestamp) {
      return []
    }
    try {
      return mo.subvalues_by_timestamp.map((item, index) => ({
        id: `speaking-time:${index}`,
        start: item.start_offset,
        end: Math.max(item.end_offset, item.start_offset + 0.5),
        color: "rgba(59, 130, 246, 0.3)",
        drag: false,
        resize: false,
      }))
    } catch {
      return []
    }
  }
}
